module.exports = __webpack_public_path__ + "img/user-06.7234905b.png";